import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IdPsConfigurationState, IdPsConfigurationStateConst } from 'src/app/AppState';

export const getIdPsConfigurationState = createFeatureSelector<IdPsConfigurationState>(IdPsConfigurationStateConst);

export const getIdPsConfiguration = createSelector(
    getIdPsConfigurationState,
    (state: IdPsConfigurationState) => state.IdPsConfiguration
);